<template>
  <div class="basic-hidden-input-container">
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
    >
      <input
        v-bind="field"
        :ref="name"
        type="hidden"
        :placeholder="placeholder"
      >
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * placeholder: placeholder that'll be set inside the textarea (string)
 * value: text that'll be set inside the input, if null, then the placeholder we'll be displayed (string)
 * name: input's name (string)
 */
export default {
  name: 'BasicHiddenInput',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: String,
    name: String,
    defaultValue: {
      type: [String, Array, Object, Number, Boolean],
      default: null
    }
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue
    }
  },
  mounted() {
    this.mutatedValue !== null
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  }
}
</script>

<style scoped>
  .basic-hidden-input-container {
    display: none;
  }
</style>
